import { createSelector } from 'reselect';

const getState = state => state.glossary;

const getData = createSelector([getState], state => state.data);

export default {
  getData,
};
